<lottie-animation-view
  [options]="configuration"
  [width]="width"
  (animCreated)="animCreated($event)"
></lottie-animation-view>
